import Cookies from "universal-cookie"

export class RightsManager {
  constructor(props) {
    const cookies = new Cookies()
    this.currentUser = cookies.get("bg_user")
  }

  userHasRole(roleName) {
    return this.currentUser.roles.includes(roleName)
  }

  userHasRight(rightName) {
    // console.log("userHasRight", this.currentUser.grantedRights, rightName, this.currentUser.grantedRights.includes(rightName))
    return this.currentUser.grantedRights.includes(rightName)
  }
}
